// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/EditPreferences/Content/Main/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_Actions_EditPreferences_Content_Main($connection_id: uuid!, $resource_id: uuid!) {
  apps_connections_by_pk(id: $connection_id) {
    id
    app {
      id
      properties: metadata(path: "connection.properties")
    }
    resources(where: { id: { _eq: $resource_id } }) {
      id
      connection_id
      resource_id
      properties
    }
  }
}

`